export default "__VITE_ASSET__CIRi3v5Z__"